module.exports = __webpack_public_path__ + "static/example_year-8b504f6630851ba3daae15b97117be7c.png";